/**
 * @generated SignedSource<<0b3b258c9e1a787246d514e2532bde46>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbLeadTime_sku$data = {
  readonly leadTime: string | null;
  readonly " $fragmentType": "PdpSharedBlurbLeadTime_sku";
};
export type PdpSharedBlurbLeadTime_sku$key = {
  readonly " $data"?: PdpSharedBlurbLeadTime_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbLeadTime_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbLeadTime_sku",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "pageType",
          "value": "PDP"
        }
      ],
      "kind": "ScalarField",
      "name": "leadTime",
      "storageKey": "leadTime(pageType:\"PDP\")"
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "c8b51bfbda45470417e53311fb8cf290";

export default node;
